import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { CompetitiveHeader } from "./CompetitiveHeader";
import { URLAnalysis } from "@/types/seo";
import { PositionMetrics } from "./metrics/PositionMetrics";
import { AuthorityMetrics } from "./metrics/AuthorityMetrics";
import { ContentMetrics } from "./metrics/ContentMetrics";
import { BooleanMetrics } from "./metrics/BooleanMetrics";

interface CompetitiveMetricsTableProps {
  urlAnalyses: URLAnalysis[];
}

export const CompetitiveMetricsTable = ({ urlAnalyses }: CompetitiveMetricsTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead style={{ width: '180px' }}>Métrica</TableHead>
          {urlAnalyses.slice(0, 3).map((analysis) => (
            <TableHead 
              key={analysis.url} 
              className="text-center" 
              style={{ width: 'calc((100% - 180px) / 3)' }}
            >
              <CompetitiveHeader analysis={analysis} />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        <PositionMetrics urlAnalyses={urlAnalyses} />
        <AuthorityMetrics urlAnalyses={urlAnalyses} />
        <ContentMetrics urlAnalyses={urlAnalyses} />
        <BooleanMetrics urlAnalyses={urlAnalyses} />
      </TableBody>
    </Table>
  );
};